import React, { Component } from 'react';
import ScreenLoader from '../ScreenLoader/ScreenLoader';
import Message from '../Message/Message';
import TradesTable from '../TradesTable/TradesTable';
import Api from '../../helpers/Api';

export default class Trades extends Component {
  static isPrivate = true;

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: null,
    };
    this.api = new Api(`bets/${props.type}`);
  }

  componentDidMount() {
    this.api.start({
      onBefore: this.requestWillStart.bind(this),
      onSuccess: this.requestDidComplete.bind(this),
      onError: this.requestDidCatch.bind(this),
    });
  }

  componentWillUnmount() {
    this.api.stop();
  }

  requestWillStart() {
    this.setState({ isLoading: true });
    this.props.updateRefresh(true, false);
  }

  requestDidComplete(data) {
    this.setState({ data, isLoading: false });
    this.props.updateRefresh(false, false);
  }

  requestDidCatch(error) {
    this.setState({ isLoading: false });
    this.props.updateRefresh(false, error instanceof Api.CancelError ? false : error);
  }

  render() {
    if (!Array.isArray(this.state.data) || this.state.data.length < 1) {
      return this.state.isLoading
        ? <ScreenLoader />
        : <Message type="warning" text="No open trades" />;
    }

    return (
      <div>
        <div className="row">
          <div className="col-xs-12 table-scroll">
            <TradesTable data={this.state.data} profitLoss={this.props.profitLoss} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Trades/Trades.js